import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import { Smile, Trash } from 'react-feather';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { useAuth, useMessage } from '../../global-components/src';
import Spinner from '../../global-components/src/components/spinner/spiner';
import { PACOCA_API_URL, PRICE_PER_VIEWS_ADS } from '../../global-components/src/utils/vars';
import { errorMessage as errorMessageUtil } from '../../utils/TextManagerTwo';

interface FilePreview {
    file: File;
    src: string;
}

interface IncreaseLimitProps {
    id_ads: number | null;
    onIncreaseLimit: () => void;
}
  
const IncreaseLimit: React.FC<IncreaseLimitProps> = ({ id_ads, onIncreaseLimit }) => {
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [text, setText] = useState("");
    const [isLimitExceeded, setIsLimitExceeded] = useState(false);
    const { token } = useAuth();
    const closeRef = useRef<HTMLButtonElement | null>(null);
    const { setMessage } = useMessage(); 
    const [walletBalance, setWalletBalance] = useState<number>(0);
    const [loadinWallet, setLoadingWallet] = useState<boolean>(true);
    const [errorsInput, setErrorsInput] = useState<{ name?: string[]; text?: string[]; expectedViews?: string[], price?: string[], img?: string[], terms?: string[], buttonText?: string[], buttonUrl?: string[] }>({});
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [expectedViews, setExpectedViews] = useState<number | null>(100);
    const [formatedAmount, setFormatedAmountformatedAmount] = useState<number>(0);
    const [value, setValue] = useState<number | null>();
    

    useEffect(() => {
        if(!expectedViews)
            setValue(null)
        else
            setValue(expectedViews * PRICE_PER_VIEWS_ADS)
    }, [expectedViews])

    useEffect(() => {
        if(value) setFormatedAmountformatedAmount(value);
    }, [value]);
    
    useEffect(() => {
        setLoadingWallet(true);

        axios.get(`${PACOCA_API_URL}/wallet`, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            setWalletBalance(Number(res.data.balance));
        }).finally(() => {
            setLoadingWallet(false);
        });
    }, []);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault(); // Impede o envio do formulário
        setLoading(true)
        setErrorsInput({});
    
        // Criação do objeto FormData
        const formData = new FormData();
        formData.append("expected_views", String(expectedViews));
    
        try {
            await axios.post(`${PACOCA_API_URL}/ads/increase-limit/${id_ads}`, formData, {
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // Adicione o token aqui
                }
            })

            cancelPost()
            setMessage("Anúncio republicado, já está online", "success")
            onIncreaseLimit()
            
            if(closeRef.current)
                closeRef.current.click()
    
        } catch (err: any) {
            const messageError = errorMessageUtil(err)
            const reason = err?.response?.data.reason && err?.response?.status == 403 ? err?.response?.data.reason : null;
            setErrorMessage(messageError);
            console.error(err);
            console.error(messageError);
            
        } finally {
            setLoading(false);
        }
    };

    const cancelPost = () =>{
        setLoading(false)
        setErrorMessage("");
        setText("");
        setIsLimitExceeded(false);
    }


  return (
    <>
        <div className="col-10">
            <form className="form-post" onSubmit={handleSubmit} id='form-increase-limits'>
                <div className="modal fade" id="increase-limits" aria-hidden="true">
                    <div className="modal-dialog cover-mobile">
                        <div id="username-suggestions"></div>
                        <div className="modal-content">
                            <div className="modal-header modal-header-add-post" style={{ borderBottom: "0!important" }}>
                                <h4 className="modal-title" id={`modal-post`}>Anúnciar</h4>
                                <button ref={closeRef} type="button" className="btn-close  btn-dark" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body" style={{ paddingTop: 0}}>
                                <div className="user-suggestions user-suggestions-new-post" style={{display: "none", position: "absolute", background: "white", border: "1px solid #ccc", zIndex: "1000", maxHeight: "200px", overflowY: "auto", top: "254px"}}></div>
                                    <div className="col-12 mt-4">
                                        <label className="required" htmlFor="expectedViews">Quantidade de visualizações esperadas: {expectedViews}</label>
                                        <input
                                            type="range"
                                            id="expectedViews"
                                            name="expectedViews"
                                            min="100"
                                            max="10000"
                                            step="100"
                                            value={expectedViews || 10}
                                            onChange={(e) => setExpectedViews(Number(e.target.value))}
                                            className={`form-range ${errorsInput.expectedViews ? 'is-invalid' : ''}`}
                                        />
                                        {errorsInput.expectedViews && (
                                            <div className="invalid-feedback" style={{ display: "block" }}>
                                            {errorsInput.expectedViews[0]}
                                            </div>
                                        )}
                                    </div>

                                    {value ? (
                                        <div className="mt-3 mb-2">
                                            Valor total do anúncio: R${value}
                                        </div>
                                    ) : null}

                                    <div className="list-group">
                                        <label className={`list-group-item notification_opened d-flex gap-3 align-items-center active`} style={{ cursor: 'pointer', opacity: formatedAmount > walletBalance ? .7 : 1 }}>
                                            <input className="form-check-input flex-shrink-0" type="radio" name="payMethod" checked={true} disabled={formatedAmount > walletBalance}/>
                                            <span>
                                                Saldo da Carteira
                                                <small className="d-block opacity-75">
                                                    {loadinWallet ? "Carregando..." : `Disponível: R$ ${walletBalance.toFixed(2).replace(".", ",")}`}
                                                </small>
                                            </span>
                                        </label>
                                    </div>

                                    <div className="invalid-feedback error-repost invalid-feedback-comment-text" style={{ display: "block" }}>
                                        {errorMessage}
                                    </div>

                                <div className="modal-footer" style={{padding: "0"}}> 
                                    <div className="loading-post"></div>
                                        <div className="row" style={{width: "100%", justifyContent: "end"}}>

                                        <div className="col-6 col-md-3 col-lg-3 col-xl-3 col-add-post-btn" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                                            <button type="button" className="btn btn-subimit-post btn-secondary btn-w-100" onClick={cancelPost} data-bs-dismiss="modal">Cancelar</button>
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-3 col-add-post-btn" style={{ paddingRight: "5px", paddingLeft: "5px" }}>
                                            <button type="submit" className={`btn-subimit-post btn btn-blue btn-w-100`} disabled={loading || isLimitExceeded}>
                                                {loading ? (
                                                    <>
                                                        <Spinner/>
                                                    </>
                                                ) : (
                                                    <>Republicar</>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </>
  );
};

export default IncreaseLimit;